/*
 * @Author: your name
 * @Date: 2020-06-18 15:06:22
 * @LastEditTime: 2020-06-18 15:24:43
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \leXiangH5线下落地页\src\router\index.js
 */
import Vue from "vue";
import VueRouter from "vue-router";
// import Home from "@/views/Home.vue";
import TechSupport from "@/views/TechSupport.vue";
import DownloadApp from "@/views/DownloadApp.vue";
import H5Code from '@/views/H5Code.vue';

Vue.use(VueRouter);

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [
  {
    path: "/",
    name: "",
    component: DownloadApp
  },
  {
    path: "/techsupport",
    name: "TechSupport",
    component: TechSupport
  },
  {
    path: "/downloadapp",
    name: "DownloadApp",
    component: DownloadApp
  },
  {
    path: "/pages/code/code",
    name: "H5Code",
    component: H5Code
  },
  {
    path: "/daTaoKeDetail",
    name: "DaTaoKeDetail",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/DaTaoKeDetail.vue")
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  // {
  //   path: "/audiovisualizer",
  //   name: "AudioVisualizer",
  //   component: () =>
  //     import("../views/AudioVisualizer.vue")
  // }
];

const router = new VueRouter({
  routes
});

export default router;
